<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                Todo el control de tu ecommerce con la solución digital de Triidy
            </h2>
            <p>
                Triidy es la solución a tus problemas de egresos e ingresos. La pensamos para que puedas escalar tu negocio rápido, con más capacidad de ventas y sin perder de vista cada transacción que realices.
            </p>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
        <div class="col right">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/personBen-new.png" alt="">
            <img class="globo1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo1-new.png" alt="">
            <img class="globo3" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo3-new.png" alt="">
            <img class="globo4" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo4-new.png" alt="">

        </div>
    </div>
    <div class="row secc2">
        <div class="col left">
            <h2>¡Acelera tu crecimiento!</h2>
            <h3>Obtén recursos para potenciar tu ecommerce</h3>
            <p>
                Sabemos que cuando inicias tu ecommerce o lo estás impulsando necesitarás dinero para acelerar tu camino, por eso cuando ingreses a Triidy te prestamos COP$1.000.000 para que compres productos a los proveedores dropshipping y puedas venderlos en todo
                Colombia. Además si ya estás en etapa de crecimiento, nuestro sistema de big data te ofrecerá más recursos para que dupliques tus ventas y no pares de crecer.
            </p>
        </div>
        <div class="col right">
            <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Compu2-new.png" alt="">
        </div>
    </div>
    <div class="row secc3">
        <h3>Caracteristicas</h3>
        <h3 style="width: 100%; text-align: center; color: #484848">¡Te entendemos! Por eso te ofrecemos todo esto:</h3>
        <div id="carouselCaracteristics" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let car of Caracteristicas" [ngClass]="{'active':car.id === 1}">
                    <div class="row caracteris">
                        <div class="col left">
                            <img [src]="car.imagen" class="" alt="...">
                        </div>
                        <div class="col right">
                            <h4>{{ car.titulo }}</h4>
                            <p [innerHTML]="car.texto"></p>
                        </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselCaracteristics" role="button" data-bs-slide="prev">
                <i class="fas fa-arrow-circle-left"></i>
                <span class="visually-hidden">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselCaracteristics" role="button" data-bs-slide="next">
                <i class="fas fa-arrow-circle-right"></i>
                <span class="visually-hidden">Next</span>
            </a>
        </div>
    </div>
    <div class="row secc4">
        <p>Ayudando a los comerciantes a hacer el negocio de sus sueños</p>
        <div class="metrica">
            <h2>+5.000</h2>
            <p>Usuarios</p>
        </div>
        <div class="metrica">
            <h2>+2.000</h2>
            <p>Productos disponibles</p>
        </div>
        <div class="metrica">
            <h2>+1.250.000</h2>
            <p>Transacciones realizadas</p>
        </div>
        <div class="metrica">
            <h2>+1.100</h2>
            <p>Ciudades y municipios</p>
        </div>
    </div>
    <div class="row secc5">
        <div class="col left">
            <h2>¡Más dinero para tu bolsillo!</h2>
            <h3>¿Sabías que no tenemos costos fijos mensuales?</h3>
            <p>En Triidy existimos para ayudar a los emprendedores digitales a descubrir su verdadero potencial, despachando a tiempo y ahorrando costos en logística.</p>
            <p><span>Conoce los beneficios de usuarios Triidy.</span></p>
            <p>Nuestra plataforma esta disponible en:</p>
            <img class="" (click)="descargaAnd()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
            <img class="" (click)="descargaWin()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
        </div>
        <div class="col right">
            <img class="fondo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Fondo6-new.png" alt="">
        </div>
    </div>
    <div class="row secc6">
        <h2>Ventajas y Beneficios</h2>
        <p>Descubre como nuestra tecnología esta revolucionando la forma de vender y generar ganacias.</p>
        <carousel class="carrou navegador" [overflowCellsLimit]="3" [loop]="true" [cellWidth]="200" [cellsToShow]="3" [autoplay]="true">
            <div class="carousel-cell" *ngFor="let ben of Beneficios">
                <div class="card2">
                    <img class="image" [src]="ben.imagen" alt="">
                    <h3>{{ ben.titulo }}</h3>
                    <p>{{ ben.parrafo }}</p>
                </div>
            </div>
        </carousel>
        <div id="carouselExampleControls2" class="carousel slide mobile" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let ben of Beneficios" [ngClass]="{'active':ben.id === 1}">
                    <div class="card2">
                        <img class="image" [src]="ben.imagen" alt="">
                        <h3>{{ ben.titulo }}</h3>
                        <p>{{ ben.parrafo }}</p>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls2" role="button" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls2" role="button" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </a>
        </div>
    </div>
    <!-- <div class="row secc7" *ngIf="newsVista">
        <p>Regístrate para recibir las últimas noticias y novedades acerca de Triidy.</p>
        <form action="" [formGroup]="newsForm" (ngSubmit)="registroNws()">
            <p class="intros">
                <input class="inputs" type="text" name="nombre" id="nombre" formControlName="nombre" required />
                <label for="nombre" alt="Nombre" placeholder="Nombre"></label>
            </p>
            <p class="intros">
                <input class="inputs" type="email" name="email" id="email" formControlName="email" required />
                <label for="email" alt="Correo" placeholder="Correo"></label>
            </p>
            <button type="submit" class="btn" [disabled]="!newsForm.valid">Suscríbete</button>
        </form>
    </div> -->
    <div class="row secc8">
        <h2>Gestiona y organiza tu tienda virtual desde tu computador o desde tu celular.</h2>
        <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
        <button class="btn" (click)="clickM()">Regístrate Ahora</button>
    </div>
    <div class="row secc9">
        <p>Con el apoyo y acompañamiento de:</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Acompa12-new.png" alt="">
    </div>
    <div>
        <base href="https://clientify.net/web-marketing/superforms/script/53530.js">
    </div>
</div>